import React, { useEffect, useState } from 'react';
import { Card, CardContent, CircularProgress, Grid, Typography, List, Stack, Button } from "@mui/material";
import { Search, SearchIconWrapper, StyledInputBase } from "app/shared/SearchGlobal/style";
import _ from "lodash";
import Div from "@jumbo/shared/Div";
import SearchIcon from "@mui/icons-material/Search";
import fileTaskServices from 'app/services/file-task-services';
import moment from 'moment';
import StateBadge from 'app/widgets/Shared/StateBadge';
import { prettyDuration } from 'app/utils/appHelpers';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CustomPagination from 'app/widgets/Shared/Pagination/CustomPagination';
// import UserEditModal from './UserEditModal';


const FileTasksIndex = () => {
    // const Swal = useSwalWrapper();
    // const theme = useTheme();
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [recordsList, setRecordsList] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [listLoading, setListLoading] = useState(false)
    const [currentUserId, setCurrentUserId] = useState(null)
    const [openRecordEditModal, setOpenRecordEditModal] = useState(false)

    useEffect(() => {
        if(listLoading){
            loadRecords()
        }
    }, [listLoading])

    useEffect(() => {
        setListLoading(true)
    }, [])

    const buildRecordParams = () => {
        let par = []
        
        par.push(`include=user`)
        par.push(`page=${currentPage}`)

        par = _.join(par, '&')

        return `?${par}`;
    }

    const loadRecords = () => {
        fileTaskServices.getFileTasks(buildRecordParams())
            .then(resp => {
                setRecordsList(resp.data)
                setTotalPages(resp.meta.total_pages)
            })
            .catch(function (error) {})
            .finally(() => {
                setListLoading(false)
            });
    }

    const handleSearchQueryChange = (newVal) => {
        setCurrentPage(1)
        setSearchQuery(newVal)
        setListLoading(true)
    }

    const debounceSearchQueryChange = _.debounce(handleSearchQueryChange, 450)

    const renderRecordsList = () => {
        if(recordsList){
            return (
                <React.Fragment>
                    <List disablePadding>
                        {_.map(recordsList, (u, i) => {
                            return (
                                <React.Fragment key={u.id}>
                                    <Card sx={{mb: 2}}>
                                        <CardContent sx={{display: 'flex'}}>
                                            <Grid container spacing={5}>
                                                <Grid item xs={12} md={4}>
                                                    <Stack
                                                        direction="column"
                                                        justifyContent="start"
                                                        alignItems="left"
                                                        spacing={0.5}>
                                                        <Typography variant={"overline"} color="primary">{moment(u.created_at).format('DD MMM HH:mm')}</Typography>
                                                        <Typography color="primary">{u.category_name}</Typography>
                                                        {/* <Typography variant={"button"} color="primary">{u.first_name} {u.last_name}</Typography> */}
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    <StateBadge
                                                        state={u.state}
                                                        stateName={u.state_name}/>
                                                    <Typography>Intentos: {u.retries}</Typography>
                                                    <Typography>Inicio {u.process_started_at && moment(u.process_started_at).format('DD MMM HH:mm')} {(u.process_started_at && u.process_ended_at) && `(${prettyDuration(u.process_started_at, u.process_ended_at)})` }</Typography>
                                                    {/* <StateBadge state={u.state} withIcon={false} /> */}
                                                </Grid>
                                                <Grid item xs={12} md={3} style={{height: '100%'}}>
                                                    <Button
                                                        href={u.file_url}
                                                        download
                                                        endIcon={<FileDownloadOutlinedIcon />}
                                                        sx={{ fontSize: 12, overflowWrap: 'anywhere', maxWidth: 300 }}
                                                    >
                                                        {u.file_name}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} md={1} style={{height: '100%'}}>
                                                    {/* <IconButton onClick={() => { setCurrentUserId(u.id); setOpenRecordEditModal(true) }}>
                                                        <EditOutlinedIcon />
                                                    </IconButton> */}
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </React.Fragment>
                            )
                        })}
                    </List>
                </React.Fragment>
            )
        } else {
            return(
                <Typography>
                    No se encontraron datos
                </Typography>
            )
        }
    }
    
    return (
        <div>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={3}
                sx={{mb: 2}}>
                <Typography variant="h2">Carga de archivos</Typography>
                {/* <Stack
                    direction="row"
                    alignItems="center"
                    spacing={3}>
                    
                    <Search sx={{maxWidth: { sm: 200, md: 350 }}}>
                        <SearchIconWrapper>
                            <SearchIcon/>
                        </SearchIconWrapper>

                        <StyledInputBase
                            placeholder="Buscar"
                            inputProps={{'aria-label': 'search'}}
                            sx={{background: 'white'}}
                            onChange={(e) => {
                                debounceSearchQueryChange(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.key == 'Enter') {
                                    handleSearchQueryChange(e.target.value)
                                }
                            }}
                        />
                    </Search>
                </Stack> */}
            </Stack>

            <Div sx={{display: listLoading ? 'block' : 'none', textAlign: 'center', my: 5}}>
                <CircularProgress color="warning"/>
            </Div>
            <Grid container spacing={3.75}>
                <Grid item xs={12}>
                    {renderRecordsList()}
                </Grid>
            </Grid>
            <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageSelect={(page) => {setCurrentPage(page); setListLoading(true)}}/>
        </div>
    );
};

export default FileTasksIndex;